import React from "react";
import { Link, useLocation } from "react-router-dom";
import { breadcrumbnext } from "../../../assets/icons";

type TBreadcrumb = {
  id: number;
  path: string;
  name: string;
  search?: string;
  hash?: string;
};

interface IBreadcrumbProps {
  data: TBreadcrumb[];
}

const Breadcrumb: React.FC<IBreadcrumbProps> = ({ data }) => {
  const { pathname } = useLocation();

  return (
    <div className="flex flex-row justify-start text-breadscrumbColor items-center md:text-sm text-xs">
      {data.map((el: TBreadcrumb) => (
        <ul className="flex flex-row items-center" key={el.id}>
          <li className="inline-flex items-center mr-1">
            <Link
              className={
                el.path === pathname
                  ? "text-black cursor-default"
                  : "hover:text-black"
              }
              to={{ pathname: el.path, search: el?.search, hash: el?.hash }}
            >
              {el.name}
            </Link>
          </li>
          {el.id !== data.length && (
            <li className="inline-flex items-center">
              <img src={breadcrumbnext} alt="next" className="h-3 w-3 mr-1 rotate-180" />
            </li>
          )}
        </ul>
      ))}
    </div>
  );
};

export default Breadcrumb;
